import PropTypes from 'prop-types';
import React, { Component } from 'react';
import NumberInputWithFeedback from '../NumberInputWithFeedback';
import styles from './ProgramType.css';

class PointRule extends Component {
  constructor(props) {
    super(props);
    const { spendingAmount, pointFromSpendingAmount } = props;
    const amountInputError =
      spendingAmount === '' ? null : this._getAmountInputError(spendingAmount);
    const pointInputError =
      pointFromSpendingAmount === ''
        ? null
        : this._getPointInputError(pointFromSpendingAmount);
    this.state = {
      amountInputError,
      pointInputError,
    };
  }

  render() {
    return (
      <div className="top30 bottom10">
        <div className="row bottom20">
          <div className="col-md-6">
            <div className={`${styles.title}`}>Spend</div>
          </div>
          <div className="col-md-6">
            <div className={`${styles['title-right']}`}>To gain points</div>
          </div>
        </div>
        <div className={`row ${styles['vertical-align']}`}>
          <div className="col-md-6">
            <div>
              <NumberInputWithFeedback
                inputValue={this.props.spendingAmount}
                onChangeValue={this._onChangeAmount}
                prefix="Rp. "
                placeholder="Rp. 0"
                errorMessage={this.state.amountInputError}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className={styles['rule-right']}>
              <NumberInputWithFeedback
                inputValue={this.props.pointFromSpendingAmount}
                onChangeValue={this._onChangePoint}
                suffix=" Points"
                placeholder="0 Points"
                errorMessage={this.state.pointInputError}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  _onChangeAmount = (e, rawAmount) => {
    const maximum = 999999999999;
    const amountInputError = this._getAmountInputError(rawAmount);
    if (rawAmount > maximum) {
      rawAmount = this.props.spendingAmount;
    }

    if ($.isNumeric(rawAmount)) {
      rawAmount = parseInt(rawAmount);
    }

    this.props.setSpendingAmount(rawAmount);

    amountInputError !== ''
      ? this.props.setDisabledNext(true)
      : this.props.setDisabledNext(false);

    this.setState({ amountInputError });
  };

  _getAmountInputError = amount => {
    let amountInputError = '';
    if (!amount) {
      amountInputError = 'Please enter a value';
    } else if (amount < 1000) {
      amountInputError = 'Minimum value is Rp 1000';
    }

    return amountInputError;
  };

  _onChangePoint = (e, rawPoint) => {
    const maximum = 999999999999;
    if (rawPoint > maximum) {
      rawPoint = this.props.pointFromSpendingAmount;
    }

    if ($.isNumeric(rawPoint)) {
      rawPoint = parseInt(rawPoint);
    }

    const pointInputError = this._getPointInputError(rawPoint);
    this.props.setPointFromSpendingAmount(rawPoint);

    pointInputError !== ''
      ? this.props.setDisabledNext(true)
      : this.props.setDisabledNext(false);

    this.setState({ pointInputError });
  };

  _getPointInputError = point => {
    let pointInputError = '';
    if (point <= 0) {
      pointInputError = 'Please enter a value';
    }

    return pointInputError;
  };
}

PointRule.propTypes = {
  spendingAmount: PropTypes.number.isRequired,
  pointFromSpendingAmount: PropTypes.func.isRequired,
  setSpendingAmount: PropTypes.func.isRequired,
  setPointFromSpendingAmount: PropTypes.func.isRequired,
};

export default PointRule;
